/* カナメイ作成のtopicspath */
jQuery(document).ready(function() {
//    get topicpath data
    (function() {
        var $breadcrumb = jQuery("#breadcrumb");
        var $breadcrumb_links = $breadcrumb.find(".breadcrumbset");

        $breadcrumb_links.each(function(index, elm) {
            var $breadcrumb_link = jQuery(elm);

            var vpath = $breadcrumb_link.attr("data-jpnic-vpath");
            if (!vpath) {
                return;
            }

//デフォルトで最初のx-breadcrumb-configを見ます。
            var vpaths = [];
            var tmp = vpath.split("/");

            tmp.shift();
            var last = tmp.pop();
            if (last !== "") {
                tmp.push(last);
            }

            var vpathtemp = "/";
            jQuery.each(tmp, function(index, item) {
                vpathtemp += item + "/";
                vpaths.push(vpathtemp);
            });
            var $topicpath_a_tags = $breadcrumb_link.find("a");
            jQuery.each(vpaths, function(index, vpath) {
//最後の１つは読み飛ばす。現在位置表示のためにある。ファイルは読まない。
                if (vpaths.length === index + 1) {
                    return;
                }
                if (index > $topicpath_a_tags.length - 2) {
                    return;
                }
                var nextVpath = null;
                if (vpaths.length > index + 1) {
                    nextVpath = vpaths[index + 1];
                }
                var localVpath = $topicpath_a_tags.eq(index).attr("data-jpnic-vpath");
                if (typeof (localVpath) !== "undefined") {
                    vpath = localVpath;
                }
                var datapath = "/common/topicpath" + vpath + "list.js";

                var d = jQuery.ajax({
                    url: datapath,
                    dataType: "json"
                });
                var depth = index + 1;
                d.done(function(data) {

                    var $blist = jQuery('<ul id="breadcrumb-depth-' + depth + '" class="breadcrumb-list" data-vpath = "' + vpath + '" data-breadcrumb-depth="' + depth + '"></ul>');
                    var $firstli = jQuery('<li/>');
                    var $subnuv = jQuery('<ul class="sub-nav"/>');

                    jQuery.each(data, function(index, item) {
                        var $a = jQuery("<a>" + item.text + "</a>").attr("href", item.href).attr("data-vpath", item.vpath);
                        var $li = jQuery(("<li/>"));
                        var re = new RegExp("^" + nextVpath);

                        if (nextVpath !== null && item.vpath.search(re) === 0 && typeof (localVpath) === "undefined") {
                            $a.addClass("jq_topicpath_now");
                            $firstli.append($a);
                        } else {
                            $subnuv.append($li.append($a));
                        }
                    });

                    $firstli.append($subnuv);
                    $blist.append($firstli);
                    $breadcrumb_link.append($blist);

//時間差で消す処理
                    var stId;
                    $blist.add($breadcrumb_link).on("mouseleave", function() {
                        stId = setTimeout(function() {
                            clearTimeout(stId);
                            $blist.hide();

                        }, 450);
                    }).on("mouseenter", function() {
                        clearTimeout(stId);
                    });
//ページのどこかをクリックで消す
                    var onTouchMoveFlag = false;
                    $(document).on("click touchstart", function(e) {
                        onTouchMoveFlag = false;
                    }).on("touchmove", function(e) {
                        onTouchMoveFlag = true;
                    }).on("touchend", function(e) {
                        if (onTouchMoveFlag) {
                            return;
                        }
                        if (e.target.parentNode.parentNode !== document.getElementById("breadcrumb")) {
                            $blist.hide();
                        }
                    });
                    $blist.on("click touchend", function(e) {
                        e.stopPropagation();
                    });
                });
            });
        });
    })();

/* Breadcrumb ==================================================== */

    (function() {
        var $bc = $("#breadcrumb");
        var $bcLink = $bc.find(".breadcrumb-link").find("a");

        if ($bcLink.size() > 1) {
            $bcLink.eq(0).removeClass("back-to-site-top");
        }

        $bcLink
            .on("mouseover click", function(e) {
                var isTouch = (function(){
// タッチデバイス判定
                    return (document.ontouchstart !== undefined);
                })();
                if(isTouch){
                    //return ;
                    e.preventDefault();
                }

            var $target = jQuery(e.target);
            var $bc = $target.closest(".breadcrumbset");
            var $bcLink = $bc.find(".breadcrumb-link").find("a");

//一番最初のリンクは普通の動作　ここでは何もしない
            if ($bcLink.index(this) === 0) {
                return;
            }

            var $bcList = $bc.find(".breadcrumb-list");
            var $link = $(this);
            var $target_bcList = $bcList.filter("[data-breadcrumb-depth=" + $bcLink.index(this) + "]");
//パンくずの階層に合わせたリストを選択
//対応するリストが読み込まれていない場合も普通の動作
            if ($target_bcList.length === 0) {
                return;
            }

//画面表示位置調整
            var xPos = $link.position().left;
            var xOffset = 15;
            var docWidth = $(window).width();
            var bcWidth = $target_bcList.outerWidth();

            if (xPos + bcWidth > docWidth - xOffset) {
                xPos = xPos - ( (xPos + bcWidth) - docWidth ) -  xOffset ;
            }

            $bcList.hide();
            $target_bcList.css({
                left: xPos
            }).show();

        });


    }());

/*--------------------------------------------------------------------------*/
/* menu
/*--------------------------------------------------------------------------*/

    $("#menu").find(".menu-toggle").on("click", function(e, param1) {
        e.preventDefault();
        var $this = $(this);
        var $sub_ul = $this.parent().children("ul");

        $sub_ul.stop(true).slideToggle(function() {
            var flag = $sub_ul.is(":visible");
            if (flag) {
                $this.addClass("open");
                $sub_ul.css({height: "auto"});
            } else {
                $this.removeClass("open");
                $sub_ul.css({height: "auto"});
            }
        });
    });

//menu open ==================================================== */
    (function() {
        var $breadcrumbs = jQuery("#breadcrumb").find(".breadcrumbset");
        $breadcrumbs.each(function(index, elm) {
            var $breadcrumb = jQuery(elm);
            var vpath = $breadcrumb.attr("data-jpnic-vpath");
            if (!vpath) {
                return;
            }
            var texts = vpath.split("/");
            var last = texts.pop;
            if (last === "") {
                last = texts.pop;
            }
            var $menu = jQuery("#menu");
            var baseVpath = $menu.attr("data-jpnic-vpath")
            var baseVpathDepth = baseVpath.split("/").length - 2;
            var vpathDepth1Texts = [];
            for (var i = 0; i < baseVpathDepth + 2; i++) {
                vpathDepth1Texts.push(texts[i]);
            }
            vpathDepth1Texts.push("");
            var vpathDepth1 = vpathDepth1Texts.join("/");
            $('.main-nav > li[data-jpnic-vpath="' + vpathDepth1 + '"] .menu-toggle',$menu).addClass("open").parent().children("ul").show();
        });
    })();
});



// WEBPACK FOOTER //
// ./src/topicpath.js